import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { AuthTokens, AuthUser } from '@/types/api'

interface AuthState {
  accessToken: string | null
  refreshToken: string | null
  user: AuthUser | null
  hydrated: boolean
  setSession: (tokens: AuthTokens) => void
  updateUser: (user: Partial<AuthUser>) => void
  clearSession: () => void
  setHydrated: (hydrated: boolean) => void
}

export const useAuthStore = create<AuthState>()(persist(
  (set) => ({
    accessToken: null, refreshToken: null, user: null, hydrated: false,
    setSession: (tokens) => set({ accessToken: tokens.accessToken, refreshToken: tokens.refreshToken, user: tokens.user }),
    updateUser: (user) => set((state) => ({ user: state.user ? { ...state.user, ...user } : null })),
    clearSession: () => set({ accessToken: null, refreshToken: null, user: null }),
    setHydrated: (hydrated) => set({ hydrated }),
  }),
  {
    name: 'eventgallery-auth',
    partialize: ({ accessToken, refreshToken, user }) => ({ accessToken, refreshToken, user }),
    onRehydrateStorage: () => (state) => state?.setHydrated(true),
  },
))
